import { useEffect, useRef, useState } from "react"
import Card from "../Card/Card"
import './Stack.scss'
import { SECTIONS } from "../PlayerSection/PlayerSection"
import MouseDropableSection from "../MouseDropableSection"
import { Button } from "react-bootstrap"
import { ACTION_MODES } from "../ActionMode"

export default function Stack(props) {
    function playLatestStackCard() {
        let card = props.latestStackCard

        if (card) {
            let type = card.isFlipped ? card.cardData.face.back.type : card.cardData.face.front.type
            let destination = props.sections.autoPlayFromStack[type]
            if (card.isTriggerEffect) {
                destination = SECTIONS.DISCARD
            }
            if (destination) {
                if (destination == ACTION_MODES.GROUP) {
                    const cardIndex = props.visibleCards.findIndex((vc) => vc.id === card.id)
                    if (cardIndex !== -1) {
                        props.setCurrentActionMode({
                            ...props.currentActionMode,
                            action: ACTION_MODES.GROUP,
                            actionData: {
                                cardToGroupIndex: cardIndex,
                                cardName: card.cardData.name
                            }
                        })
                    }
                } else {
                    props.moveCard(card, destination)
                    props.repositionCards()
                }
            }
        }
    }

    function randomizeYourCards() {
        // randomize z index for all your cards in the stack
        props.stackCards.forEach((c) => {
            console.log(c.card.owner, props.playerId)
            if (c.card.owner === props.playerId) {
                c.card.stackIndex = Math.floor(Math.random() * 101) - 101;
                console.log(c)
            }
            // if owner, new index = random 0, -100
        })
        // reposition
        props.repositionCards()
    }

    return (
        <MouseDropableSection
            className="stack"
            sectionRef={props.stackRef}
            section={SECTIONS.STACK}
            cardDraggedRef={props.cardDraggedRef}
            moveCard={props.moveCard}
            repositionCards={props.repositionCards}
            displayedTitle={props.displayedTitle}
        >
            <div className="buttons w-100 position-absolute d-flex"
                style={props.latestStackCard ? {} : { opacity: 0, pointerEvents: 'none' }}
            >
                <Button className="w-100" onClick={() => playLatestStackCard()}>Play</Button>
                {/*<Button className="ms-1" onClick={() => randomizeYourCards()}><img src={require('../Assets/dice.png')} /></Button>*/}
            </div>
        </MouseDropableSection>
    )
}